import moment from 'moment'

export const statusOptions = [
	{
		label: '推广中',
		value: 1
	},
	{
		label: '已关闭',
		value: 2
	}
]

export const goodsPlatOptions = [
	{
		label: '淘宝',
		value: 10
	},
	{
		label: '京东',
		value: 16
	},
	{
		label: '拼多多',
		value: 7
	},
	{
		label: '唯品会',
		value: 9
	}
]

export const renderList = [
	{
		label: '商品推广ID',
		key: 'goodsId',
		type: 'input',
		placeholder: '请输入'
	},
	{
		label: '状态',
		key: 'status',
		type: 'select',
		placeholder: '请选择',
		options: statusOptions
	},
	{
		label: '电商平台',
		key: 'goodsPlatId',
		type: 'select',
		placeholder: '请选择',
		options: goodsPlatOptions
	},
	{
		label: '商品名称',
		key: 'goodsName',
		type: 'input',
		placeholder: '请输入'
	}
]

export const renderMobileList = [
	{
		label: '商品名称',
		key: 'goodsName',
		type: 'input',
		placeholder: '请输入',

		//style: `margin-left: 0.3rem`
	},
	{
		label: '商品推广ID',
		key: 'goodsId',
		type: 'input',
		placeholder: '请输入',
		isRowEnd: true,
	},
	{
		label: '状态',
		key: 'status',
		type: 'picker',
		placeholder: '请选择',
		options: [{ label: '无', value: undefined }, ...statusOptions]
	},
	{
		label: '电商平台',
		key: 'goodsPlatId',
		type: 'picker',
		placeholder: '请选择',
		options: [{ label: '无', value: undefined }, ...goodsPlatOptions],
		isRowEnd: true,
	},
]



// WEBPACK FOOTER //
// ./src/pages/home/goodsInfo/goodsList/config.js